import { DrawingToolHelpers } from "../../../helpers/drawing-tool-helpers";
import { IComponent } from "../../component.interface";
import { IDrawingTool } from "../drawing-tool.interface";
import { DrawingToolsManager } from "../drawing-tools.manager";

export class TimeCyclesComponent implements IComponent, IDrawingTool {
    public id = '';

    public annotation: any = null;
    private drawingToolManager: DrawingToolsManager;

    constructor(drawingToolManager: DrawingToolsManager, id: string) {
        this.drawingToolManager = drawingToolManager;
        this.id = id;
    }

    public static syncCreate(drawingToolManager: DrawingToolsManager, annotationOptions: any): TimeCyclesComponent {
        const chart: any = drawingToolManager.base.tiChartSeries.highStockChart;
        
        annotationOptions.typeOptions.points[0].x = DrawingToolHelpers.calculateXPosition(
            annotationOptions.typeOptions.points[0].actualXValue,
            annotationOptions.typeOptions.points[0].actualStartTimeT,
            drawingToolManager);

        annotationOptions.typeOptions.points[1].x = DrawingToolHelpers.calculateXPosition(
            annotationOptions.typeOptions.points[1].actualXValue,
            annotationOptions.typeOptions.points[1].actualStartTimeT,
            drawingToolManager);

        const component = new TimeCyclesComponent(drawingToolManager, annotationOptions.id);
        const addedNewAnnotation: any = chart.addAnnotation(annotationOptions);

        drawingToolManager.updateAnnotationStyles(addedNewAnnotation, annotationOptions, false);
        component.annotation = addedNewAnnotation;
        return component;
    }

    public static create(drawingToolManager: DrawingToolsManager, event: any): TimeCyclesComponent {
        const component = new TimeCyclesComponent(drawingToolManager, event.options.id);
        component.annotation = event;
        return component;
    }

    public syncUpdate(annotationOptions: any) {

    }

    public getMetaData(): any {
        const firstPoint = this.annotation.options.typeOptions.points[0];
        const actualFirstPosition = DrawingToolHelpers.getActualStartTimePosition(firstPoint, this.drawingToolManager);

        const secondPoint = this.annotation.options.typeOptions.points[1];
        const actualSecondPosition = DrawingToolHelpers.getActualStartTimePosition(secondPoint, this.drawingToolManager);

        return {
            id: this.id,
            langKey: "timeCycles",
            type: 'timeCycles', // options type
            typeOptions: {
                xAxis: this.annotation.options.typeOptions.xAxis,
                yAxis: this.annotation.options.typeOptions.yAxis,
                points: [{
                    x: this.annotation.options.typeOptions.points[0].x,
                    
                    actualStartTimeT: actualFirstPosition?.actualStartTimeT,
                    actualXValue: actualFirstPosition?.actualXValue,

                    y: this.annotation.options.typeOptions.points[0].y,
                }, {
                    x: this.annotation.options.typeOptions.points[1].x,
                    
                    actualStartTimeT: actualSecondPosition?.actualStartTimeT,
                    actualXValue: actualSecondPosition?.actualXValue,

                    y: this.annotation.options.typeOptions.points[1].y,
                }]
            }
        };
    }
}